export * from "./fileImport"
export * from "./page"

export type WASM_METHODS = "toJSON" | "toString" | "free"

export enum Decorator {
  NOT_APPLICABLE,
  INVALID,
  VALID,
  VALID_GUESS,
}
